import React from "react";

// ASSETS
import SecondIllustration from "assets/icons/margin dialogue.svg";

// STYLES
import {
  ParentContainer,
  Section,
  SectionSecondIllustration,
} from "./CivicDialogueCardsSectionStyled";

// LIBRARIES

// MISC
import { IProps } from "./CivicDialogueCardsSectionModel";

// REDUX

// COMPONENTS
import CivicDialoguePageCustomCard from "components/CivicDialoguePageCustomCard/CivicDialoguePageCustomCard";

const CivicDialogueCardsSection: React.FC<IProps> = ({ cards }) => {
  // PROPERTIES

  // LIBRARY CONSTANTS

  // STATE CONSTANTS

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS

  return (
    <ParentContainer>
      <SectionSecondIllustration src={SecondIllustration} alt="" />
      <Section>
        {cards.map((card, index) => (
          <CivicDialoguePageCustomCard
            key={index}
            type={card.type}
            content={card.content}
            colSpan={card.colSpan}
            rowSpan={card.rowSpan}
          />
        ))}
      </Section>
    </ParentContainer>
  );
};

export default CivicDialogueCardsSection;
